<template>
  <v-container class="donate-page py-8">
    <v-progress-linear v-if="loading" indeterminate />
    <v-alert v-if="error" type="error" variant="tonal">{{ error }}</v-alert>
    <v-row v-if="donationFund && options" align="stretch" justify="center">
      <v-col cols="12" md="6">
        <v-card class="h-100" rounded="lg" variant="outlined">
          <DonationPurpose
            :purpose="donationInitiative ?? donationFund"
            :name="donationInitiative?.initiativeName ?? donationFund.fundName"
          />
          <InitiativeProgress
            v-if="
              donationInitiative?.isGoalPublic &&
              donationInitiative.contributionsGoal
            "
            :donation-initiative="donationInitiative"
            :donation-amount-cents="donationAmountCents"
          />
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <DonationForm
          :fund="donationFund"
          :initiative="donationInitiative"
          :options="options"
          @fund-changed="fundSelected = $event"
          @amount-changed="donationAmountCents = $event"
        />
      </v-col>
    </v-row>
    <v-alert v-else-if="!loading && !error" type="warning"
      >This donation purpose is not currently available.</v-alert
    >
  </v-container>
</template>
<script lang="ts" setup>
import InitiativeProgress from "@/components/donations/InitiativeProgress.vue";
import {
  useDonationNew,
  type DonationOptions,
} from "@/composables/donations/useDonationNew";
const route = useRoute();
const donations = useDonationNew();
const options = ref<DonationOptions>();
const donationAmountCents = ref(0);
const fundSelected = ref<number>();
const loading = ref(true);
const error = ref("");
const donationInitiative = computed(() =>
  options.value?.initiatives.find(
    (a) => a.initiativeName === route.query.initiativeName,
  ),
);
const donationFund = computed(() => {
  if (route.query.initiativeName && !donationInitiative.value) return undefined;
  const fixed = donationInitiative.value?.targetFund?.fundId;
  const selected = fixed ?? fundSelected.value;
  return options.value?.funds.find((a) =>
    selected != null
      ? a.fundId === selected && (fixed != null || a.showInCheckout)
      : a.showInCheckout &&
        a.fundName === (route.query.fundName || "General Operating"),
  );
});
watch(
  () => [route.query.fundName, route.query.initiativeName],
  () => {
    fundSelected.value = undefined;
  },
);
onMounted(async () => {
  try {
    options.value = await donations.fetchDonationOptions();
  } catch (cause) {
    error.value =
      cause instanceof Error
        ? cause.message
        : "Unable to load donation options.";
  } finally {
    loading.value = false;
  }
});
</script>
<style scoped>
.donate-page {
  max-width: 1200px;
}
</style>
